/* istanbul ignore file */
import React from 'react';
import { useShowContext } from 'framework/show';
import { useDateTimeService } from 'framework/utils';

import TimelineRecordAuthorWithAccessCheck from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/TimelineRecordAuthorWithAccessCheck';
import { Box } from '@mui/material';

const TimelineRecordFooter = ({ isUpdateAuthorHidden = false, noTopIndent = false }) => {
  const { data: entity } = useShowContext();
  const updatedAt = entity.getValueBySource('updatedAt');
  const updatedByName = entity.getValueBySource('updatedByName');
  const updatedById = entity.getValueBySource('updatedById');
  const { formatDateWithFullFormat } = useDateTimeService();

  return updatedAt && !isUpdateAuthorHidden ? (
    <Box
      alignItems="flex-end"
      mt={noTopIndent ? 0 : '0.75rem'}
      sx={theme => ({ [theme.breakpoints.up('md')]: { display: 'flex !important' } })}
    >
      <Box ml="auto" fontSize="11px" color="text.secondary">
        Last updated {formatDateWithFullFormat(updatedAt)} by{' '}
        <TimelineRecordAuthorWithAccessCheck id={updatedById} name={updatedByName} />
      </Box>
    </Box>
  ) : null;
};

export default TimelineRecordFooter;
